import { render } from "./ChangeOwnershipModal.vue?vue&type=template&id=206f41bb&ts=true"
import script from "./ChangeOwnershipModal.vue?vue&type=script&lang=ts"
export * from "./ChangeOwnershipModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__